import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';
import { RfqReview } from '@modules/review';
import { Box, Checkbox, Grid } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useStyles from './styles';
import { useSelector } from '@store';

const CheckDueDateBox = () => {
  const classes = useStyles();

  const { control, watch } = useFormContext<RfqReview>();

  const checkedInDueDate = useSelector((state) => state.review.inDueDate);

  const { inDueDate } = watch();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.checkDueDate}
    >
      <Grid
        item
        container
        alignItems="center"
        justifyContent="center"
        className={classes.question}
      >
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="700"
        >
          납기일을 잘 지켰나요?
        </CustomizedTypography>
        <CustomizedTypography variant="body1" color="error" fontWeight="700">
          &nbsp;*
        </CustomizedTypography>
      </Grid>

      <Controller
        control={control}
        name="inDueDate"
        defaultValue={checkedInDueDate}
        render={({ onChange }) => (
          <Grid item container className="checkBoxContainer">
            <Box
              className={clsx('checkBox', {
                checked: inDueDate
              })}
              onClick={() => onChange(true)}
            >
              <CustomizedTypography
                variant="body2"
                color="textPrimary"
                fontWeight="500"
              >
                원하는 날짜에 제품을 받았습니다.
              </CustomizedTypography>
              <Checkbox color="default" checked={!!inDueDate} />
            </Box>
            <Box
              className={clsx('checkBox', {
                checked: !inDueDate
              })}
              onClick={() => onChange(false)}
            >
              <CustomizedTypography
                variant="body2"
                color="textPrimary"
                fontWeight="500"
              >
                원하는 날짜에 제품을 받지 못했습니다.
              </CustomizedTypography>
              <Checkbox color="default" checked={!inDueDate} />
            </Box>
          </Grid>
        )}
      />
    </Grid>
  );
};

export default CheckDueDateBox;
